import React, { useState } from "react";
import { Form, Button, Row, Col, Dropdown, FormControl } from "react-bootstrap";
import "./Filtri.css";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../Redux/Store";
import { urleventi } from "../lib/api.ts";
import { allGet } from "../Redux/Actions.tsx";

interface FormFiltriEventiProps {
  onClose: () => void;
  setTable: (data: any[]) => void;
  filtroEvento: {
    titolo: string;
    dataOraStart: string;
    dataOraEnd: string;
    scadenzaStart: string;
    scadenzaEnd: string;
    cantiereNome: string;
    contrattoQuadroCodice: string;
  };
  setFiltroEvento: React.Dispatch<
    React.SetStateAction<{
      titolo: string;
      dataOraStart: string;
      dataOraEnd: string;
      scadenzaStart: string;
      scadenzaEnd: string;
      cantiereNome: string;
      contrattoQuadroCodice: string;
    }>
  >;
}

const FormFiltriEventi: React.FC<FormFiltriEventiProps> = ({
  onClose,
  setTable,
  filtroEvento,
  setFiltroEvento,
}) => {
  const dispatch: AppDispatch = useDispatch();
  const { token } = useSelector((state: RootState) => state.login);
  const { eventi } = useSelector((state: RootState) => state.eventi);
  const { cantieri } = useSelector((state: RootState) => state.cantieri);
  const { contratti } = useSelector((state: RootState) => state.contratti);
  const { committenti } = useSelector((state: RootState) => state.committenti);

  // Stati di ricerca locale per i Dropdown
  const [titoloSearchText, setTitoloSearchText] = useState("");
  const [cantiereSearchText, setCantiereSearchText] = useState("");
  const [contrattoSearchText, setContrattoSearchText] = useState("");

  const handleChange = (name: string, value: string) => {
    setFiltroEvento((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = () => {
    let url = `${urleventi}/filter?`;

    if (filtroEvento.titolo) url += `titolo=${filtroEvento.titolo}`;
    if (filtroEvento.dataOraStart)
      url += `&dataOraStart=${filtroEvento.dataOraStart}`;
    if (filtroEvento.dataOraEnd)
      url += `&dataOraEnd=${filtroEvento.dataOraEnd}`;
    if (filtroEvento.scadenzaStart)
      url += `&scadenzaStart=${filtroEvento.scadenzaStart}`;
    if (filtroEvento.scadenzaEnd)
      url += `&scadenzaEnd=${filtroEvento.scadenzaEnd}`;
    if (filtroEvento.cantiereNome)
      url += `&cantiereNome=${filtroEvento.cantiereNome}`;
    if (filtroEvento.contrattoQuadroCodice)
      url += `&contrattoQuadroCodice=${filtroEvento.contrattoQuadroCodice}`;

    dispatch(allGet(url, token)).then((filteredData) => {
      if (filteredData) {
        const eventiConDati = filteredData.map((evento: any) => ({
          ...evento,
          committente:
            committenti.find((c) => c.id === evento.committenteId)
              ?.ragioneSociale || "N/A",
          contrattoQuadro:
            contratti.find((c) => c.id === evento.contrattoQuadroId)?.codice ||
            "N/A",
          cantiere:
            cantieri.find((c) => c.id === evento.cantiereId)?.nome || "N/A",
        }));

        setTable(eventiConDati);
        onClose();
      } else {
        console.error("Errore nel caricamento dei filtri Eventi");
      }
    });
  };

  const handleReset = () => {
    setFiltroEvento({
      titolo: "",
      dataOraStart: "",
      dataOraEnd: "",
      scadenzaStart: "",
      scadenzaEnd: "",
      cantiereNome: "",
      contrattoQuadroCodice: "",
    });
    setTitoloSearchText("");
    setCantiereSearchText("");
    setContrattoSearchText("");

    dispatch(allGet(urleventi, token)).then((data: any) => {
      if (data) {
        const eventiConDati = data.map((evento: any) => ({
          ...evento,
          committente:
            committenti.find((c) => c.id === evento.committenteId)
              ?.ragioneSociale || "N/A",
          contrattoQuadro:
            contratti.find((c) => c.id === evento.contrattoQuadroId)?.codice ||
            "N/A",
          cantiere:
            cantieri.find((c) => c.id === evento.cantiereId)?.nome || "N/A",
        }));

        setTable(eventiConDati);
      }
    });
  };

  return (
    <div className="form-filtri-eventi">
      {/* Titolo come dropdown con ricerca */}
      <Form.Group className="mb-3">
        <Form.Label htmlFor="titolo">Titolo</Form.Label>
        <Dropdown>
          <Dropdown.Toggle
            variant="outline-secondary"
            className="w-100 input-crea-edit p-0 h-2r"
            id="titoloEventoDropdown"
          >
            {filtroEvento.titolo ? filtroEvento.titolo : "Seleziona Titolo"}
          </Dropdown.Toggle>

          <Dropdown.Menu
            style={{ maxHeight: "300px", width: "100%", overflowY: "auto" }}
          >
            <FormControl
              autoFocus
              className="w-100"
              placeholder="Filtra per Titolo"
              onChange={(e) => setTitoloSearchText(e.target.value)}
              value={titoloSearchText}
            />
            <Dropdown.Divider />

            {eventi
              .filter((ev) =>
                ev.titolo
                  ?.toLowerCase()
                  .includes(titoloSearchText.toLowerCase())
              )
              .map((ev: any, idx: number) => (
                <Dropdown.Item
                  key={idx}
                  onClick={() => handleChange("titolo", ev.titolo)}
                >
                  {ev.titolo}
                </Dropdown.Item>
              ))}
          </Dropdown.Menu>
        </Dropdown>
      </Form.Group>

      {/* Cantiere come dropdown con ricerca */}
      <Form.Group className="mb-3">
        <Form.Label>Cantiere</Form.Label>
        <Dropdown>
          <Dropdown.Toggle
            variant="outline-secondary"
            className="w-100 input-crea-edit p-0 h-2r"
            id="cantiereNomeDropdown"
          >
            {filtroEvento.cantiereNome
              ? filtroEvento.cantiereNome
              : "Seleziona Cantiere"}
          </Dropdown.Toggle>

          <Dropdown.Menu
            style={{ maxHeight: "300px", width: "100%", overflowY: "auto" }}
          >
            <FormControl
              autoFocus
              className="w-100"
              placeholder="Filtra per Nome Cantiere"
              onChange={(e) => setCantiereSearchText(e.target.value)}
              value={cantiereSearchText}
            />
            <Dropdown.Divider />

            {cantieri
              .filter((c) =>
                c.nome.toLowerCase().includes(cantiereSearchText.toLowerCase())
              )
              .map((c: any, idx: number) => (
                <Dropdown.Item
                  key={idx}
                  onClick={() => handleChange("cantiereNome", c.nome)}
                >
                  {c.nome}
                </Dropdown.Item>
              ))}
          </Dropdown.Menu>
        </Dropdown>
      </Form.Group>

      {/* Contratto Quadro come dropdown con ricerca */}
      <Form.Group className="mb-3">
        <Form.Label>Contratto Quadro</Form.Label>
        <Dropdown>
          <Dropdown.Toggle
            variant="outline-secondary"
            className="w-100 input-crea-edit p-0 h-2r"
            id="contrattoQuadroDropdown"
          >
            {filtroEvento.contrattoQuadroCodice
              ? filtroEvento.contrattoQuadroCodice
              : "Seleziona Contratto Quadro"}
          </Dropdown.Toggle>

          <Dropdown.Menu
            style={{ maxHeight: "300px", width: "100%", overflowY: "auto" }}
          >
            <FormControl
              autoFocus
              className="w-100"
              placeholder="Filtra per Codice Contratto"
              onChange={(e) => setContrattoSearchText(e.target.value)}
              value={contrattoSearchText}
            />
            <Dropdown.Divider />

            {contratti
              .filter((c) =>
                c.codice
                  ?.toLowerCase()
                  .includes(contrattoSearchText.toLowerCase())
              )
              .map((contratto: any, idx: number) => (
                <Dropdown.Item
                  key={idx}
                  onClick={() =>
                    handleChange("contrattoQuadroCodice", contratto.codice)
                  }
                >
                  {contratto.codice}
                </Dropdown.Item>
              ))}
          </Dropdown.Menu>
        </Dropdown>
      </Form.Group>

      {/* Data Esecuzione */}
      <Form.Group className="mb-3">
        <Form.Label>Data Esecuzione</Form.Label>
        <Row>
          <Col>
            <Form.Control
              type="date"
              value={filtroEvento.dataOraStart}
              onChange={(e) => handleChange("dataOraStart", e.target.value)}
              placeholder="Da"
            />
          </Col>
          <Col>
            <Form.Control
              type="date"
              value={filtroEvento.dataOraEnd}
              onChange={(e) => handleChange("dataOraEnd", e.target.value)}
              placeholder="A"
            />
          </Col>
        </Row>
      </Form.Group>

      {/* Scadenza */}
      <Form.Group className="mb-3">
        <Form.Label>Scadenza</Form.Label>
        <Row>
          <Col>
            <Form.Control
              type="date"
              value={filtroEvento.scadenzaStart}
              onChange={(e) => handleChange("scadenzaStart", e.target.value)}
              placeholder="Da"
            />
          </Col>
          <Col>
            <Form.Control
              type="date"
              value={filtroEvento.scadenzaEnd}
              onChange={(e) => handleChange("scadenzaEnd", e.target.value)}
              placeholder="A"
            />
          </Col>
        </Row>
      </Form.Group>

      {/* Pulsanti */}
      <Row>
        <Col className="text-end">
          <Button variant="secondary" onClick={handleReset}>
            Cancella Filtri
          </Button>
          <Button className="button ms-2" onClick={handleSubmit}>
            Applica Filtri
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default FormFiltriEventi;
